import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-push-to-talk-wrapper',
  templateUrl: './push-to-talk-wrapper.component.html',
  styleUrls: ['./push-to-talk-wrapper.component.css']
})
export class PushToTalkWrapperComponent implements OnInit {
  subMenu = 'driver';

  ngOnInit() {
  }

  onSelectSubMenu(menu) {
    this.subMenu = menu;
  }
}
